import React, { useState, useEffect, useCallback } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import {
  isAfter,
  parse,
  isValid,
  format,
  isEqual,
  isBefore,
  parseISO,
  toDate,
  startOfDay,
  differenceInCalendarMonths,
} from "date-fns";

import {
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Text,
} from "@chakra-ui/react";

import CriancaService from "../../../../../../../main/services/CriancaService";
import { CustomButton } from "../../../../../../components/CustomButton";
import { CustomSelectWField } from "../../../../../../components/CustomSelectWField";
import { FocusError } from "../../../../../../components/FocusError";
import ConfirmationModal from "../../../../Cadastrar/Movimentacao/ConfirmationModal";
import { CustomDatepickerWField } from "../../../../../../components/CustomDatepickerWField";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import VisitasService from "../../../../../../../main/services/VisitasService";
import ServicoAcolhimentoService from "../../../../../../../main/services/ServicoAcolhimentoService";
import {
  Permission,
  servicos,
} from "../../../../../../../helpers/Funcionalidades";
import { hasFormChanged } from "../../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../../Context/MessageContextProvider";
import { useFormikContext } from "formik";
import LoadingSpinner from "../../../../../../components/LoadingSpinner";
import { useHistory, useLocation } from "react-router";

export const VisitaModal = ({
  isOpen,
  onOpen,
  onClose,
  onCloseFiliacoes,
  form,
  filiacoes,
  setNovaFiliacao,
  initialFiliacao,
  roleKeycloack,
  idCrianca,
  fetchVisitasData,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [relations, setRelations] = useState({ options: [], isLoading: false });
  const [servicosData, setServicosData] = useState({
    options: [],
    isLoading: false,
  });
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption] = useState(null);
  const [valuesForm, setValuesForm] = useState(null);
  const {
    cadastrarVisita,
    setCadastrarVisita,
    primeiraMovimentacao,
    ultimaMovimentacao,
  } = useAppContext();

  const gestorTribunalMin = roleKeycloack?.includes(
    servicos.servicoVisitaCrianca
  );

  const [initialValues, setInitialValues] = useState({
    idServicoAcolhimento: "",
    gestorTribunalMin: gestorTribunalMin,
    crianca: "",
    visitante: "",
    data: "",
  });
  const [dataFutura, setDataFutura] = useState(false);
  const [foraPeriodo, setForaPeriodo] = useState(false);
  const [servicoValid, setServicoValid] = useState(false);
  const [isValidData, setIsValidData] = useState(false);
  const [vistaDataNascimento, setVistaDataNascimento] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const schema = Yup.object().shape({
    idServicoAcolhimento: Yup.object().when(["gestorTribunalMin"], {
      is: (gestorTribunalMin) => {
        if (gestorTribunalMin) {
          return true;
        } else {
          return false;
        }
      },
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable().notRequired(),
    }),
    crianca: Yup.object().nullable().required("Este campo é obrigatório!"),
    visitante: Yup.object().nullable().required("Este campo é obrigatório!"),
    data: Yup.string()
      .required("Este campo é obrigatório!")
      .nullable()
      .test("foraPeriodo", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isBefore(
            parse(value, "dd/MM/yyyy", new Date()),
            startOfDay(toDate(primeiraMovimentacao))
          );
        }
      })
      .test("foraPeriodo", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !(
            isAfter(
              parse(value.data, "dd/MM/yyyy", new Date()),
              startOfDay(toDate(ultimaMovimentacao.dataMovimentacao))
            ) && ultimaMovimentacao.movimento.tipoSituacao.id === 2
          );
        }
      })
      .test("validDate", "", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .test("dataNascimentoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      })
      .test("dataVisitaAfterNascimento", "", function (value) {
        const { data, crianca } = this.parent;

        if (!!data && !!crianca && crianca.dataNascimento) {
          const dataNascimento = new Date(crianca.dataNascimento);

          const partesData = value.split("/");
          const dataVisita = new Date(
            partesData[2],
            partesData[1] - 1,
            partesData[0]
          );

          return (
            isAfter(dataVisita, dataNascimento) ||
            isEqual(dataVisita, dataNascimento)
          );
        } else {
          return false;
        }
      }),
  });

  const backAlert = () => {
    if (cadastrarVisita) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarVisita(false);
          setServicoValid(false);
        }
      });
    } else {
      onClose();
    }
  };

  const addVisitaCrianca = async (id, valuesToSend) => {
    const dataVisita = parseISO(valuesToSend.dataVisita);
    const mesesDeDiferenca = differenceInCalendarMonths(new Date(), dataVisita);

    try {
      await VisitasService.postVisitas(id, valuesToSend);
      ["42", "43"].includes(idTipoPendencia) &&
        history.replace(location.pathname);
      Swal.fire({
        title: "Sucesso!",
        html: `Registro cadastrado com sucesso! ${
          mesesDeDiferenca >= 7
            ? `<br /><div style="text-align: justify; margin-top: 8px; font-size: 14px;">
           Visitas cadastradas há mais de 6 meses são registradas na AGENDA DE VISITAS localizada no menu lateral do sistema.
         </div>`
            : ""
        }`,
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchVisitasData();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message
          ? error.response.data.message
          : "Erro ao cadastrar visita.",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const handleGetServicos = useCallback((dataVisita, selectedCrianca) => {
    let dataFormatada;
    setServicosData((prevState) => ({ ...prevState, isLoading: true }));

    if (dataVisita) {
      dataFormatada = format(
        parse(dataVisita, "dd/MM/yyyy", new Date()),
        "yyyy-MM-dd"
      );
    }

    ServicoAcolhimentoService.getServicosAcolhimentoCrianca(
      selectedCrianca.value,
      dataFormatada ? dataFormatada : ""
    ).then((res) => {
      if (res.data.length === 0) {
        setServicoValid(true);
      } else {
        setServicoValid(false);
      }
      setServicosData({ options: res.data, isLoading: false });
    });
  }, []);

  useEffect(() => {
    if (valuesForm?.data && valuesForm?.data?.length === 10 && isValidData) {
      handleGetServicos(valuesForm?.data, valuesForm?.crianca);
    }
  }, [valuesForm?.data, handleGetServicos, isValidData, valuesForm?.crianca]);

  const FocusErrorData = () => {
    const { values, errors, submitForm } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { data } = values;
        const currentDate = new Date();

        if (data) {
          if (
            isValid(parse(data, "dd/MM/yyyy", new Date())) &&
            data.length === 10
          ) {
            const dataValue = parse(values?.data, "dd/MM/yyyy", new Date());
            const dataFormatada = format(dataValue, "dd/MM/yyyy");
            const movementDate = parse(data, "dd/MM/yyyy", new Date());

            if (isAfter(movementDate, currentDate)) {
              setDataFutura(true);
            } else {
              setDataFutura(false);
            }

            if (
              values.data.length === 10 &&
              isBefore(
                parseISO(dataFormatada),
                startOfDay(toDate(primeiraMovimentacao))
              )
            ) {
              setForaPeriodo(true);
            } else if (
              values.data.length === 10 &&
              isAfter(
                parseISO(dataFormatada),
                startOfDay(toDate(ultimaMovimentacao?.dataMovimentacao))
              ) &&
              ultimaMovimentacao?.movimento?.tipoSituacao?.id === 2
            ) {
              setForaPeriodo(true);
            } else {
              setForaPeriodo(false);
            }
          }

          if (!!values.data) {
            if (values.data.length === 10) {
              if (isValid(parse(values.data, "dd/MM/yyyy", new Date()))) {
                setIsValidData(true);
              }
            } else {
              setIsValidData(false);
            }
          } else {
            setIsValidData(true);
          }

          if (
            !!values.data &&
            !!values.crianca &&
            values.crianca.dataNascimento
          ) {
            const dataNascimento = new Date(values.crianca.dataNascimento);

            const partesData = values.data.split("/");
            const dataVisita = new Date(
              partesData[2],
              partesData[1] - 1,
              partesData[0]
            );

            setVistaDataNascimento(
              isAfter(dataVisita, dataNascimento) ||
                isEqual(dataVisita, dataNascimento)
            );
          } else {
            setVistaDataNascimento(false);
          }
        }
      };

      if (errors.data && values.data) {
        submitForm();
      }
      validateDate();
    }, [values, values.dataNascimento, errors.data, submitForm]);

    return null;
  };

  useEffect(() => {
    const handleGetCrianca = async () => {
      await CriancaService.getCrianca(idCrianca).then((res) => {
        let primeiraMovimentacao;

        if (res.data?.movimentacoes && res.data?.movimentacoes.length > 0) {
          const movimentacoesComData = res.data?.movimentacoes.filter(
            (item) => item.ordem
          );

          if (movimentacoesComData.length > 0) {
            movimentacoesComData.sort((a, b) => b.ordem - a.ordem);

            primeiraMovimentacao = movimentacoesComData[0];
          }
        }

        const formattedOptions = {
          dataAcolhimento: primeiraMovimentacao?.dataMovimentacao,
          dataNascimento: res.data.dataNascimento,
          label:
            res.data.nome +
            `${res.data.nomeSocial ? ` / ${res?.data?.nomeSocial}` : ""}`,
          value: res.data.id,
        };

        setInitialValues((prevValues) => ({
          ...prevValues,
          crianca: formattedOptions,
        }));
      });
    };

    handleGetCrianca();
  }, [idCrianca]);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { crianca, visitante, data, idServicoAcolhimento } = values;

      const splitDate = data.split("/");
      const year = parseInt(splitDate[2]);
      const month = parseInt(splitDate[1]) - 1;
      const day = parseInt(splitDate[0]);
      const now = new Date();

      const formattedDate = new Date(
        year,
        month,
        day,
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      );
      const formattedDateString = format(
        formattedDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
      );

      const criancaAdolescente = {
        idCrianca: crianca ? crianca.value : "",
      };

      let valuesToSend;

      if (gestorTribunalMin) {
        valuesToSend = {
          idServicoAcolhimento: idServicoAcolhimento
            ? idServicoAcolhimento.id
            : "",
          dataVisita: data ? formattedDateString : "",
          idPessoaFisicaVisitante: visitante ? visitante.id : "",
        };
      } else {
        valuesToSend = {
          idServicoAcolhimento: null,
          dataVisita: data ? formattedDateString : "",
          idPessoaFisicaVisitante: visitante ? visitante.id : "",
        };
      }

      addVisitaCrianca(criancaAdolescente.idCrianca, valuesToSend);

      actions.setSubmitting(false);
    }, 200);
  };

  const handleGetRelacionamento = (props) => {
    let dataFormatada;
    setRelations({ ...[], isLoading: true });

    if (props.values.data) {
      dataFormatada = format(
        parse(props.values.data, "dd/MM/yyyy", new Date()),
        "yyyy-MM-dd"
      );
    }

    VisitasService.relacionamentosVisita(
      idCrianca,
      dataFormatada ? dataFormatada : "",
      props.values?.idServicoAcolhimento?.id
        ? props?.values?.idServicoAcolhimento?.id
        : null
    ).then((res) => {
      setRelations({ options: res.data, isLoading: false });
    });
  };

  const handleConfirmAction = (props) => {
    props.setFieldValue("tipoTermoGuarda", selectedOption);

    setIsConfirmationModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "50%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {"Cadastrar Visita".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{
              base: "0px",
              md: servicosData.isLoading ? "100px" : "200px",
            }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarVisita(
                    hasFormChanged(initialValues, props.values)
                  )}
                  {setValuesForm(props.values)}

                  <FocusError />
                  <FocusErrorData />

                  <input
                    type="text"
                    style={{ position: "absolute", left: "-9999px" }}
                  />
                  {servicosData.isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <Grid templateColumns="repeat(6, 1fr) 1fr" gap={2}>
                      <GridItem colSpan={{ base: 7, md: 2 }}>
                        <VStack alignItems="flex-start">
                          <CustomDatepickerWField
                            fieldName="data"
                            label="Data*"
                            placeholder="DD/MM/AAAA"
                            maxDate={new Date()}
                            clear={() => {
                              props.setFieldValue("visitante", "");
                              props.setFieldValue("idServicoAcolhimento", "");
                              setServicosData({
                                options: [],
                                isLoading: false,
                              });
                            }}
                            setIsFocused={setIsFocused}
                            autoFocus={false}
                          />
                          {props.values.data &&
                            foraPeriodo &&
                            !dataFutura &&
                            vistaDataNascimento && (
                              <Text color="red" opacity={0.8} fontSize="12px">
                                Data da visita informada fora do período do
                                acolhimento.
                              </Text>
                            )}

                          {props.values.data &&
                            servicoValid &&
                            isValidData &&
                            !dataFutura &&
                            !foraPeriodo &&
                            vistaDataNascimento && (
                              <Text color="red" opacity={0.8} fontSize="12px">
                                Data da visita informada fora do período do
                                acolhimento.
                              </Text>
                            )}

                          {props.values.data && dataFutura && isValidData && (
                            <Text color="red" opacity={0.8} fontSize="12px">
                              A data informada não pode ser uma data futura!
                            </Text>
                          )}
                          {props.values.data && !isValidData && !isFocused && (
                            <Text color="red" opacity={0.8} fontSize="12px">
                              Data inválida!
                            </Text>
                          )}

                          {props.values.data &&
                            !vistaDataNascimento &&
                            isValidData && (
                              <Text color="red" opacity={0.8} fontSize="12px">
                                Data da visita informada menor que a data de
                                nascimento do acolhido.
                              </Text>
                            )}
                        </VStack>
                      </GridItem>
                      <GridItem colSpan={{ base: 7, md: 5 }}>
                        <CustomSelectWField
                          fieldName="crianca"
                          label="Criança / Adolescente*"
                          placeholder="Selecione a criança/adolescente"
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          options={props.values.crianca}
                          defaultValue={props.values.crianca}
                          isDisabled={true}
                          onChange={(value) => {
                            props.setFieldValue("crianca", value);
                          }}
                        />
                      </GridItem>

                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={servicos.servicoVisitaCrianca}
                      >
                        <GridItem colSpan={7}>
                          <CustomSelectWField
                            mt={2}
                            fieldName="idServicoAcolhimento"
                            label="Serviço de Acolhimento*"
                            placeholder="Selecione o Serviço de Acolhimento"
                            getOptionLabel={(option) => option?.nome}
                            getOptionValue={(option) => option.id}
                            isLoading={servicosData.isLoading}
                            options={servicosData.options}
                            onChange={(value) => {
                              props.setFieldValue(
                                "idServicoAcolhimento",
                                value
                              );
                              props.setFieldValue("visitante", "");
                            }}
                            isDisabled={
                              servicoValid ||
                              !props.values.data ||
                              props.values.errors ||
                              props.values.data.length !== 10 ||
                              dataFutura ||
                              foraPeriodo ||
                              !isValidData
                            }
                          />
                        </GridItem>
                      </Permission>

                      <GridItem colSpan={7}>
                        <CustomSelectWField
                          mt={1}
                          fieldName="visitante"
                          label="Visitante*"
                          placeholder="Selecione o visitante"
                          getOptionLabel={(option) => option.nome}
                          getOptionValue={(option) => option.id}
                          isLoading={relations.isLoading}
                          options={relations.options}
                          onChange={(value) => {
                            props.setFieldValue("visitante", value);
                          }}
                          onFocus={() => handleGetRelacionamento(props)}
                          isDisabled={
                            servicoValid ||
                            !props.values.data ||
                            props.values.errors ||
                            props.values.data.length !== 10 ||
                            dataFutura ||
                            foraPeriodo ||
                            !isValidData
                          }
                        />
                      </GridItem>

                      <GridItem colSpan={3}>
                        <SimpleGrid
                          mt="25px"
                          columns={2}
                          spacing="15px"
                          w={{ base: "100%", lg: "80%" }}
                        >
                          <CustomButton onClick={backAlert} label="Cancelar" />
                          <CustomButton
                            type="submit"
                            translate="no"
                            isLoading={props.isSubmitting}
                            label="Salvar"
                          />
                        </SimpleGrid>
                      </GridItem>
                    </Grid>
                  )}

                  <ConfirmationModal
                    isOpen={isConfirmationModalOpen}
                    selectedOption={selectedOption}
                    onClose={() => setIsConfirmationModalOpen(false)}
                    onConfirm={() => handleConfirmAction(props)}
                    tipo={"guarda"}
                  />
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
